import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { SmartLinkAlignment, SmartLinkDirection, SmartLinkPosition, SmartLinkSize, SmartLinkWidth } from '../../../../../constants';
import { getBaseStyles, getGapSize, renderChildren } from '../utils';
import { getMaxLineHeight, getTruncateStyles } from '../../utils';
var getAlignmentStyles = function getAlignmentStyles(align) {
  switch (align) {
    case SmartLinkAlignment.Right:
      return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        -webkit-box-align: end;\n        -ms-flex-align: end;\n        justify-content: flex-end;\n        text-align: right;\n      "])));
    case SmartLinkAlignment.Left:
    default:
      return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        -webkit-box-align: start;\n        -ms-flex-align: start;\n        justify-content: flex-start;\n        text-align: left;\n      "])));
  }
};
var getGapStyles = function getGapStyles(size, align) {
  var gap = getGapSize(size);
  if (align === SmartLinkAlignment.Right) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      > span {\n        margin-left: ", "rem;\n      }\n\n      > span:first-child {\n        margin-left: initial;\n      }\n    "])), gap);
  }
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    > span {\n      margin-right: ", "rem;\n      &:last-child {\n        margin-right: initial;\n      }\n    }\n  "])), gap);
};
var getHorizontalDirectionStyles = function getHorizontalDirectionStyles(size, align) {
  var lineHeight = getMaxLineHeight(size);
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: block;\n    vertical-align: middle;\n    ", "\n\n    > span, > div {\n      vertical-align: middle;\n\n      &[data-smart-element-date-time],\n      &[data-smart-element-text] {\n        // Show all/wrapped/truncated\n        display: inline;\n      }\n    }\n\n    ", "\n  "])), getTruncateStyles(1, lineHeight + 'rem'), getGapStyles(size, align));
};
export var getElementGroupStyles = function getElementGroupStyles(direction, size, align, width, position) {
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  min-width: 10%;\n  ", "\n  ", "\n  ", "\n"])), getBaseStyles(direction, size), getAlignmentStyles(align), width === SmartLinkWidth.Flexible ? "flex: 1 3;" : '', direction === SmartLinkDirection.Horizontal ? getHorizontalDirectionStyles(size, align) : '', position === SmartLinkPosition.Top ? 'align-self: flex-start;' : '');
};

/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */
var ElementGroup = function ElementGroup(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? SmartLinkAlignment.Left : _ref$align,
    children = _ref.children,
    overrideCss = _ref.overrideCss,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? SmartLinkDirection.Horizontal : _ref$direction,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SmartLinkSize.Medium : _ref$size,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-element-group' : _ref$testId,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? SmartLinkWidth.FitToContent : _ref$width,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? SmartLinkPosition.Center : _ref$position;
  return jsx("div", {
    css: [getElementGroupStyles(direction, size, align, width, position), overrideCss],
    "data-smart-element-group": true,
    "data-testid": testId
  }, renderChildren(children, size));
};
export default ElementGroup;